import React from 'react';
import styled from 'styled-components';
import { Paper } from '@material-ui/core';

import useOneCardDb from '../hooks/useOneCardDb';
import useDrawCardContentDb from '../hooks/useDrawCardContentDb';
import { initial } from './index';

type CardPaperProps = {
  width: number;
  height: number;
  $frameDisplay?: boolean;
  $frameColor?: string;
  $backgroundDisplay?: boolean;
  $backgroundColor?: string;
}
const CardPaper = styled(Paper)<CardPaperProps>`
  position: relative;
  width: ${props => props.width + 'px'};
  min-height: ${props => props.height + 'px'};
  border: ${props => props.$frameDisplay ? '1px solid ' + props.$frameColor : undefined};
  background-color: ${props => props.$backgroundDisplay ? props.$backgroundColor : '#11ffee00'};
  box-sizing: border-box;
  overflow: hidden;
`
const DrawImg = styled.img`
  position: absolute;
`

type DrawCardProps = {
  cardId: string;
  widthValue?: number;
  heightValue?: number;
}
const DrawCard: React.FC<DrawCardProps> = ({cardId, widthValue, heightValue}) => {
  const card = useOneCardDb(cardId);
  const [, drawContentValue] = useDrawCardContentDb(cardId);
  if (!card) return <></>;

  const width = widthValue ? widthValue : card.currentWidth ? card.currentWidth : initial.cardWidth;
  const height = heightValue ? heightValue : card.currentHeight ? card.currentHeight : initial.cardHeight;

  return (
    <CardPaper className="magica-card"
      width={width} height={height}
      $frameDisplay={card.frame.display} $frameColor={card.frame.color}
      $backgroundDisplay={card.background.display} $backgroundColor={card.background.color}
    >
    { (drawContentValue && drawContentValue.content !== '') &&
      <DrawImg src={drawContentValue.content} draggable="false" width={width} height={height} />
    }
    </CardPaper>
  );
}

export default DrawCard;
